import { CircularProgress, Container } from "@material-ui/core";
import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import AdminHome from "./Admin/AdminHome";
import { AuthContext } from "./Auth/AuthContextProvider";
import AuthRedirect from "./Auth/AuthRedirect";
import AuthRoute from "./Auth/AuthRoute";
import TopNav from "./Base/TopNav";
import Home from "./Home/Home";
import MyRegistrations from "./UserPages/Dashboard/MyRegistrations";
import UserEditProfile from "./UserPages/EditProfile/UserEditProfile";
import AdoptionRegistrationForm from "./UserPages/RegistrationForm/AdoptionRegistrationForm";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  skipToContent: {
    position: "absolute",
    left: "-9999px",
    top: "100px",
    zIndex: theme.zIndex.drawer + 10,
    "&:focus": {
      left: "50%",
      transform: "translateX(-50%)",
      top: 0,
    },
  },
}));

export default function AppRoutes() {
  const authContext = React.useContext(AuthContext);
  const classes = useStyles();

  // Display a loading spinner until authentication has initialized
  return (
    <Router>
      {authContext.initialized ? (
        <>
          <Button href="#main-content" className={classes.skipToContent} variant="contained" sx={{ ml: 1 }}>
            Skip to Content
          </Button>
          <TopNav />
          <main id="main-content" tabIndex={-1}>
            <Switch>
              <AuthRoute path="/admin" adminRoute component={AdminHome} />
              <AuthRoute path="/profile" component={UserEditProfile} />
              <AuthRoute path="/my-registrations" component={MyRegistrations} />
              <AuthRoute path="/registration" exact component={AdoptionRegistrationForm} />
              <AuthRoute path="/registration/:userFriendlyId" component={AdoptionRegistrationForm} />
              <Route path="/auth-redirect" component={AuthRedirect} />
              <Route path="/" component={Home} />
            </Switch>
          </main>
        </>
      ) : (
        <Container
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "30vh",
          }}
        >
          <CircularProgress />
        </Container>
      )}
    </Router>
  );
}
